import { StandardButton } from "../atoms/buttons"
import { HorizontalLayout, VerticalLayout } from "../components/layout"
import { icon } from "../functions/icons"

export const SettingsHeader = ({title,description, toggleAddModal, button = true}) => {
return(
    <>
<HorizontalLayout className="phone-column" style={{width:"unset", padding:"1rem", marginBottom:"0.2rem", gap:"1rem",}}>
        <VerticalLayout className="settings-header phone-setting-header">
          <h5 className="standard-margin-left standard-margin-top settings-header-title">
          {title}
          </h5>
          <h6 className="standard-margin-left standard-small-margin-top settings-sub-title">
            {description}
          </h6>
        </VerticalLayout>
        { button && 
        <StandardButton
          onClick={toggleAddModal}
          title={<>{icon("plus", 16)} {title} toevoegen</>}
        />
        }
      </HorizontalLayout>
            <div
        className="divider standard-margin-bottom"
      ></div>
      </>
)
}
